var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"pa-3 d-flex flex-wrap  my-3  justify-center",attrs:{"width":"100%"}},_vm._l((10),function(i){return _c('v-skeleton-loader',{key:i,staticClass:"ma-1",attrs:{"width":"40%","max-width":"400px","type":"card"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }